const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/fleet-management/contracts/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';

// Every draft field the wizard can produce a server-side error for — kept in
// step with WizardDraft's keys so a rejection on any step highlights inline.

export const Route = createFileRoute('/_app/fleet-management/contracts/new')({
  staticData: {
    breadCrumb: 'Add Contract'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});